export default __webpack_public_path__ + "img/align-right.0a2a7842.svg";